import React from 'react';
import { Smartphone } from 'lucide-react';
import miniProgramQRCode from '../../跑伴-小程序码.png';

interface MiniProgramQRCodeProps {
  size?: 'small' | 'medium' | 'large';
  showTitle?: boolean;
  className?: string;
}

const MiniProgramQRCode: React.FC<MiniProgramQRCodeProps> = ({
  size = 'medium',
  showTitle = true,
  className = '',
}) => {
  const sizeClasses = {
    small: 'w-32 h-32',
    medium: 'w-48 h-48',
    large: 'w-64 h-64',
  };

  return (
    <div className={`text-center ${className}`}>
      {showTitle && (
        <div className="mb-4">
          <Smartphone className="w-8 h-8 text-orange-500 mx-auto mb-2" />
          <h3 className="text-lg font-bold text-gray-900">微信小程序</h3>
          <p className="text-sm text-gray-600">扫码体验完整功能</p>
        </div>
      )}
      
      <div className={`${sizeClasses[size]} bg-white border-4 border-orange-500 rounded-2xl mx-auto p-4 shadow-lg`}>
        <img 
          src={miniProgramQRCode} 
          alt="跑伴小程序码"
          className="w-full h-full object-contain rounded-lg"
        />
      </div>
      
      <div className="mt-4 space-y-2">
        <p className="text-sm text-gray-600">
          <span className="font-semibold">使用方式：</span>
        </p>
        <ol className="text-xs text-gray-500 space-y-1">
          <li>1. 打开微信扫一扫</li>
          <li>2. 扫描上方小程序码</li>
          <li>3. 或在微信搜索"跑伴"</li>
        </ol>
      </div>
      
      <div className="mt-4 p-3 bg-green-50 rounded-lg border border-green-200">
        <p className="text-xs text-green-700">
          ✓ 已集成真实小程序码，扫码即可体验完整功能
        </p>
      </div>
    </div>
  );
};

export default MiniProgramQRCode;
